import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import FileUpload from '../common/FileUpload';
import { Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from '../../store/app-slice/app';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { UploadFile, handleSetChosenFile, handleSetChosenName, handleToggleImportTrainingDataDialog } from '../../store/mltester-slice/mltester';
import { useTranslation } from 'react-i18next';
import { handleNotificationVariant } from '../notifications/_common';
import { Header } from '../common/Header';
import RedirectIconButton from '../common/RedirectIconButton';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ImportTesterTrainingData = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const open = useAppSelector((state: RootState) => state.mltester.openImportTrainingDataDialog);
    const chosenFile = useAppSelector((state: RootState) => state.mltester.chosenFile);
    const chosenName = useAppSelector((state: RootState) => state.mltester.chosenName);
    const uploadingFile = useAppSelector((state: RootState) => state.mltester.uploadingFile);

    function handleClose() {
        dispatch(handleToggleImportTrainingDataDialog(false));
    }
    
    async function proceedToUpload() {
        if(!chosenName || !chosenFile) {
            dispatch(enqueueSnackbar({ message: t('FILE_NAME_VALIDATION'), options: { variant: 'error', persist: true } }));
            return;
        }

        const formData = new FormData();
        formData.append('file', chosenFile);
        formData.append('name', chosenName);

        dispatch(UploadFile(formData)).then((res : any) => {
            if(res && res.payload) { 
                dispatch(enqueueSnackbar({ 
                    message: t(`${res.payload.message}`), 
                    options: { 
                        variant: handleNotificationVariant(res.payload.success),
                        persist: !res.payload.success
                    } 
                }))
            }
        });
    }

    async function handleChooseFile(file: any) {
        dispatch(handleSetChosenFile(file));
    }

    return(
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={(_, reason) => {
                if(reason !== 'backdropClick' && !uploadingFile) {
                    handleClose();
                }
            }}
            aria-describedby="alert-dialog-slide-description"
        >
            <Header
                title={t('IMPORT_TESTER_TESTING_DATA_DIALONG_TITLE')} 
                helperIcon={
                    <RedirectIconButton to={'/help/6'} className="helper-icon" >
                        <ContactSupportIcon />
                    </RedirectIconButton>
                }
            />
            <Grid container p={2} spacing={2} display="flex" flexDirection="column" sx={uploadingFile ? { pointerEvents: 'none' } : {}}>
                <Grid item>
                    <TextField 
                        label={t('IMPORT_DIALOG_NAME_TITLE')}
                        fullWidth
                        required
                        value={chosenName}
                        onChange={(e) => dispatch(handleSetChosenName(e.target.value))}
                        size="small"
                    />
                </Grid>
                <Grid item>
                    <FileUpload chooseFile={handleChooseFile}/>
                </Grid>
                <Grid item>
                    { chosenFile ? <Typography variant='body1'>{t('CHOSEN_FILE_TITLE', { chosenFile: chosenFile.name })}</Typography> : '' }
                </Grid>
                <Grid item><Divider /></Grid>
                { uploadingFile ? 
                <Grid item>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                </Grid> :
                <Grid item>
                    <Grid container sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button size="small" onClick={() => handleClose()} sx={{ color: '#436372', marginRight: '10px' }}>{t('IMPORT_DIALOG_CLOSE_BUTTON')}</Button>
                        <Button size="small" onClick={() => proceedToUpload()} variant='contained' className="button-color">{t('IMPORT_DIALOG_PROCEED_BUTTON')}</Button>
                    </Grid>
                </Grid> }
            </Grid>
        </Dialog>
    )
}

export default ImportTesterTrainingData;